import {
	defAction
}from "../../../helpers/defaultAction"
import {
	organizationConstructionMaterialPriceChangeConstants
}from "./constants"
import api from './api'
import downloadFile from "../../../helpers/downloadFile"

export const organizationConstructionMaterialPriceChangeActions = {
	clear,
	create,
	remove,
	removeSelected,
	removeFiltered,
	getPaged,
	getPagedByAdmin,
	update,
	updateByAdmin,
	deleteSelectedByAdmin,
	deleteFilteredByAdmin,
	getPricesFile,
	getOrganizations,
	getLastPricePaged,
	getExampleFile,
	getByFile
}

function getByFile(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetByFile,
		service   : {
			func   : api.getByFile,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getExampleFile(){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetExampleFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон.xlsx")
	}
	return defAction(dispatchObj)
}

function getPricesFile(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetPricesFile,
		service   : {
			func   : api.getPricesFile,
			params : values
		},
		sucFunction: (res) => downloadFile(res, "Цены организаций.xlsx")
	}
	return defAction(dispatchObj)
}

function getLastPricePaged(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetLastPricePaged,
		service   : {
			func   : api.getLastPricePaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedByAdmin(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetPaged,
		service   : {
			func   : api.getPagedByAdmin,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateByAdmin(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Update,
		service   : {
			func   : api.updateByAdmin,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getOrganizations(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.GetOrganizations,
		service   : {
			func   : api.getOrganizations,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function removeSelected(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Delete,
		service   : {
			func   : api.deleteSelected,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function removeFiltered(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Delete,
		service   : {
			func   : api.deleteFiltered,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteSelectedByAdmin(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Delete,
		service   : {
			func   : api.deleteSelectedByAdmin,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteFilteredByAdmin(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Delete,
		service   : {
			func   : api.deleteFilteredByAdmin,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : organizationConstructionMaterialPriceChangeConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
  	return (dispatch) => dispatch({
  		type: organizationConstructionMaterialPriceChangeConstants.CLEAR
  	})
}
